import type { Components } from 'react-markdown';

import VideoLink from '@/components/video/VideoLink';

import { DomainConfigurationDto } from '@/types/DomainConfigurationDto';

import { isYoutubeVideoUrl } from '@/constants/youtube-constants';

import { getExternalLinkTarget } from '@/helpers/external-link-helper';

/**
 * `CinemaDescriptionMarkdown` `components` override for freeform operator-entered markdown (cinema
 * about text, cinema room descriptions, showing tag/special descriptions, …): a YouTube link opens
 * the video player modal instead of navigating, every other link honors the domain's external-link
 * target preference.
 */
export function getVideoAwareMarkdownComponents(
    domainConfiguration: DomainConfigurationDto,
    trackingEvent?: string
): Partial<Components> {
    const externalLinkTarget = getExternalLinkTarget(domainConfiguration?.websiteConfiguration);

    return {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        a: ({ node, href, ...props }) => {
            if (isYoutubeVideoUrl(href)) {
                return (
                    <VideoLink
                        url={href}
                        className="underline text-[var(--secondary-color)]"
                        trackingEvent={trackingEvent}>
                        {props.children}
                    </VideoLink>
                );
            }
            return (
                <a
                    {...props}
                    href={href}
                    target={externalLinkTarget.target}
                    rel={externalLinkTarget.rel}
                    className="underline text-[var(--secondary-color)]"
                />
            );
        }
    };
}
